import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button, Accordion } from "react-bootstrap";
import heroBg from "../assets/images/HeroBanner.png";
import { FaArrowUp, FaUsers, FaCalendarAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "../styles/WFOT.css";

const WFOTMembership = () => {
  const [tokenState, setTokenState] = useState(localStorage.getItem("token"));
  const navigate = useNavigate();

  const handleMemberLogin = () => {
    navigate("/member-login");
  };

  const handleEdcclogin = () => {
    navigate("/edcc-login");
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const currentToken = localStorage.getItem("token");
      if (currentToken !== tokenState){
        setTokenState(currentToken);
      }
    }, 500);
    return () => clearInterval(interval);
  }, [tokenState]);

  const faqData = [
    {
      question: "I am a member of AIOTA. Can I directly apply for WFOT Individual Membership subscription?",
      answer: "AIOTA life members who wish to apply for WFOT Individual Membership subscription can do it only through AIOTA.",
    },
    {
      question: "What is the validity for WFOT Individual Membership subscription?",
      answer: "1 Year.",
    },
    {
      question: "How do I make payment for WFOT Individual Membership subscription?",
      answer: "Fees for the WFOT Individual Membership subscription can be done only through DD in the name of All India Occupational Therapists’ Association(AIOTA) payable at Mumbai(For treasurer’s postal address, kindly refer AIOTA executive members list from the AIOTA website).",
    },
    {
      question: "When can I apply for WFOT Individual Membership subscription?",
      answer: "AIOTA applies WFOT Individual Membership subscription for AIOTA Life Members once in a year. Those who wish to take the WFOT membership should make the necessary payment in the month of October.",
    },
    {
      question: "What are the documents needed to apply for WFOT Individual Membership subscription?",
      answer: "You have to send your AIOTA Membership certificate copy, ACOT/IOTR certificate copy and requisition letter to honorary treasurer of AIOTA (For treasurer’s postal address, kindly refer AIOTA executive members list from the AIOTA website )",
    },
    {
      question: "What is the fees for WFOT Individual Membership subscription?",
      answer: "The amount for WFOT Individual Membership subscription registration would vary each year. You can check out the AIOTA website( www.aiota.org) to confirm the amount . It will be displayed in the website in the month of October every year.",
    },
    {
      question: "When does AIOTA apply for the WFOT Individual Membership subscription? How long will it take for the membership subscription to be activated?",
      answer: "AIOTA will collectively apply for the WFOT Individual Membership subscription in the month of January. It would take minimum 3 months for the membership subscription to be activated.",
    },
    {
      question: "Will I be receiving any certificates or ID card for WFOT Individual Membership subscription?",
      answer: "The softcopy of the certificate will be shared by WFOT. There wont be any ID cards given by WFOT for individual membership subscription.",
    },
    {
      question: "Whom can I contact for any queries or delays after applying for WFOT Individual Membership subscription?",
      answer: "For any further information regarding the same or for any delays in receiving the membership subscription approval, please contact WFOT directly- admin@wfot.org",
    },
  ]

  return (
    <>
      {/* Fixed Hero file  Section */}
      <section
        className="hero-fixed"
        style={{ backgroundImage: `url(${heroBg})` }}>

        <div className="hero-scroll-content">
          <div className="hero-content-home poppins-regular">
            <h1 className="hero-heading">All India Occupational Therapists' Association</h1>
              {!tokenState && (
                <div className="hero-buttons">
                <button className="glass-button" onClick={handleMemberLogin}>
                  Member Login
                </button>
                <button className="glass-button" onClick={handleEdcclogin}>
                  Ergonomic Certificate login
                </button>
              </div>
              )}
          </div>
        </div>
      </section>

      {/* Scrollable Content Container */}
      <div className="scrollable-content-home">
        <div className="content-container">
          <section className="wfot-content-section">
            <Container>
              <Row>
                <Col className="text-center">
                  <h1 className="section-title-wfot">WFOT Individual Membership Subscription | WFOT</h1>
                </Col>
              </Row>
              <Row>
                <Col>
                  <p className="content-text">
                    AIOTA collectively applies for WFOT Individual Membership subscription for its Life Members once a year (i.e., in the month of January). Those who wish to take the WFOT Individual Membership subscription should make the necessary payment in the month of October; it would take minimum 3 months for the membership subscription to be activated. The softcopy of the certificate will be shared by WFOT. AIOTA Life Members who wish to apply for WFOT Individual Membership subscription can do it only through AIOTA. There won't be any ID cards or user ID or password given by WFOT for Individual Membership subscription. Only your name will be listed in the WFOT website, i.e., only receiving the membership approval. The validity for WFOT Individual Membership subscription is 1 year. For any further information regarding the same or for any delays in receiving the membership approval, please contact WFOT directly admin@wfot.org
                  </p>
                </Col>
              </Row>
              <Row>
                <Col>
                  <p className="content-text">
                    For more details, kindly visit the WFOT website{" "}
                    <a
                      href="https://wfot.org/membership/individual-members"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      https://wfot.org/membership/individual-members
                    </a>
                  </p>
                </Col>
              </Row>
              <Row className="mb-4">
                <Col>
                <h3>How to Apply?</h3>
                <p>You should send the following to the treasurer of AIOTA by post (You may get the current treasurer's postal address at&nbsp; 

                  <a href="https://aiota.org/executives"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://aiota.org/executives
                  </a>
                  ) :
                </p>
                <ul>
                  <li>A request letter stating that you would like to get the WFOT Individual Membership subscription.</li>
                  <li>Your AIOTA Life Membership Certificate(hardcopy).</li>
                  <li>Your IOTR/ACOT Certificate(hardcopy)</li>
                  <li>DD of Rupees 2500 in the name of All India Occupational Therapists’ Association(AIOTA) payable at Mumbai (Treasurer's address)</li>
                </ul>
                </Col>
              </Row>

              {/* FAQ */}
              <Row className="mb-4">
                <Col>
                  <h4 className="">Frequently Asked Questions</h4>
                  <Accordion className="faq-accordion">
                    {faqData.map((item, index) => (
                      <Accordion.Item
                        eventKey={String(index)}
                        key={index}
                        className="faq-accordion-item"
                      >
                        <Accordion.Header className="faq-accordion-header">
                          {`${item.question}`}
                        </Accordion.Header>
                        <Accordion.Body className="faq-accordion-body ms-5">
                          {item.answer}
                        </Accordion.Body>
                      </Accordion.Item>
                    ))}
                  </Accordion>
                </Col>
              </Row>

              {/* <Row>
                <Col className="d-flex flex-column align-items-center">
                  <h2 className="section-titler">
                    Click below button to apply
                  </h2>
                  <Button onClick={() => navigate('/wfot-form')}>
                    Apply Now
                  </Button>
                </Col>
              </Row> */}
            </Container>
          </section>
        </div>
      </div>
    </>
  );
};

export default WFOTMembership;